import { motion } from 'motion/react'

type SignupStepActionsProps = {
  busy: boolean
  initializing: boolean
  signupStep: number
  totalSignupSteps: number
  previousStepLabel: string
  nextStepLabel: string
  signupCtaLabel: string
  onPreviousSignupStep: () => void
  onNextSignupStep: () => void
}

export const SignupStepActions = ({
  busy,
  initializing,
  signupStep,
  totalSignupSteps,
  previousStepLabel,
  nextStepLabel,
  signupCtaLabel,
  onPreviousSignupStep,
  onNextSignupStep,
}: SignupStepActionsProps) => {
  const disabled = busy || initializing
  const isLastStep = signupStep >= totalSignupSteps
  const showBackButton = signupStep > 1
  const primaryLabel = isLastStep ? signupCtaLabel : nextStepLabel

  return (
    <div className="space-y-3 pt-2">
      <div className={`flex items-center gap-2 ${showBackButton ? 'justify-between' : 'justify-end'}`}>
        {showBackButton ? (
          <button
            type="button"
            onClick={onPreviousSignupStep}
            disabled={disabled}
            className="ca-btn-secondary inline-flex h-11 items-center justify-center gap-1.5 rounded-lg border border-(--color-border-default) bg-(--color-bg-card) px-4 text-sm font-medium text-(--color-text-secondary) transition-colors duration-150 hover:text-(--color-text-primary) disabled:cursor-not-allowed disabled:opacity-50"
          >
            <svg viewBox="0 0 16 16" className="h-3.5 w-3.5 fill-none stroke-current stroke-[2]" aria-hidden>
              <path d="m10.5 3.5-4 4 4 4" />
            </svg>
            {previousStepLabel}
          </button>
        ) : null}

        <motion.button
          type={isLastStep ? 'submit' : 'button'}
          onClick={isLastStep ? undefined : onNextSignupStep}
          disabled={disabled}
          whileHover={{ scale: 1.01 }}
          whileTap={{ scale: 0.97 }}
          transition={{ duration: 0.15 }}
          className="ca-btn-primary inline-flex h-12 w-full items-center justify-center gap-2 rounded-lg px-4 text-sm font-semibold shadow-[0_14px_26px_-22px_color-mix(in_srgb,var(--color-action-primary)_85%,transparent)] disabled:cursor-not-allowed disabled:opacity-60 sm:min-w-[210px]"
        >
          {busy ? (
            <svg className="h-4 w-4 animate-spin fill-none stroke-current stroke-[2]" viewBox="0 0 16 16" aria-hidden>
              <circle cx="8" cy="8" r="6" className="opacity-25" />
              <path d="M14 8a6 6 0 0 0-6-6" className="opacity-90" />
            </svg>
          ) : null}
          {primaryLabel}
        </motion.button>
      </div>
    </div>
  )
}
